import { Link } from "react-router-dom";
import { scoops } from "@/mocks/scoops";
import VerdictBadge from "@/components/base/VerdictBadge";
import SectionHeading from "@/components/feature/SectionHeading";

const claims: Record<string, { claim: string; found: string }> = {
  "s260910-01": {
    claim: "“只是个别员工操作不规范，公司不知情。”",
    found: "视频、进货单据与排班表可交叉对应，属门店层面管理问题。",
  },
  "s260909-02": {
    claim: "“这就是公司内部裁员名单，一个不差。”",
    found: "列顺序与公司系统模板不符，存在二次编辑痕迹。",
  },
  "s260904-03": {
    claim: "“善款去向不明，账目对不上。”",
    found: "完整收支表与票据逐笔对应，质疑源于截图裁掉了表头。",
  },
  "s260901-05": {
    claim: "“检测结果严重超标，不能吃。”",
    found: "复检仅高于企业内控标准，与网传数值不在同一量级。",
  },
};

export default function ComparePreview() {
  const rows = scoops.filter((s) => claims[s.id]);

  return (
    <section className="mx-auto max-w-[1200px] px-4 py-14 md:px-8 md:py-16" aria-labelledby="compare-heading">
      <div id="compare-heading">
        <SectionHeading
          eyebrow="真假对照"
          title="网传说法 vs 核实结果"
          desc="把流传版本和核验到的事实并排放在一起，差异往往一眼就能看出来。"
          action={{ label: "查看完整求证中心", to: "/verify" }}
        />
      </div>

      <div className="overflow-hidden rounded-lg border border-background-200">
        <div className="hidden md:grid md:grid-cols-[1.4fr_1.4fr_auto] gap-4 bg-foreground-950 px-6 py-3.5 font-label text-[11px] uppercase tracking-widest text-background-300">
          <span>网传说法</span>
          <span>我们核验到的事实</span>
          <span className="text-right">结论</span>
        </div>

        <div className="divide-y divide-background-200">
          {rows.map((row) => {
            const data = claims[row.id];
            return (
              <div key={row.id} className="grid grid-cols-1 gap-3 bg-background-50 px-5 py-5 md:grid-cols-[1.4fr_1.4fr_auto] md:items-start md:gap-4 md:px-6">
                <div>
                  <span className="mb-1 block font-label text-[10px] uppercase tracking-widest text-foreground-400 md:hidden">网传说法</span>
                  <p className="text-sm leading-relaxed text-foreground-600">{data.claim}</p>
                  <Link
                    to={`/scoop/${row.id}`}
                    className="mt-2 inline-flex items-center gap-1 font-label text-[11px] text-primary-600 transition-colors hover:text-primary-700"
                  >
                    {row.code}
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </Link>
                </div>
                <div>
                  <span className="mb-1 block font-label text-[10px] uppercase tracking-widest text-foreground-400 md:hidden">核验事实</span>
                  <p className="text-sm leading-relaxed text-foreground-900">{data.found}</p>
                </div>
                <div className="md:text-right">
                  <VerdictBadge verdict={row.verdict} size="sm" />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <p className="mt-4 flex items-start gap-2 text-xs leading-relaxed text-foreground-500">
        <i className="ri-information-line mt-0.5 text-foreground-400" aria-hidden="true"></i>
        对照表中的说法均来自公开传播的原始版本，核查过程与材料出处可在对应档案中查看。
      </p>
    </section>
  );
}